import { DownloadOutlined } from "@ant-design/icons";
import { LoadingButton } from "@src/lib/ui-react";
import { useCallback } from "react";

import { useGetLatestWorkplaceAgreement } from "./api/useGetLatestWorkplaceAgreement";

interface Props {
  workplaceId: string;
}

export function WorkplaceAgreementDownloadButton({ workplaceId }: Props) {
  const { data, isLoading, latestAgreement } = useGetLatestWorkplaceAgreement(workplaceId, {
    include: ["document"],
  });

  const documentId = latestAgreement?.relationships?.document?.data?.id;
  const documentUrl = documentId
    ? data?.included?.find((document) => document.id === documentId)?.attributes.url
    : undefined;

  const handleClick = useCallback(() => {
    if (documentUrl) {
      window.open(documentUrl, "_blank");
    }
  }, [documentUrl]);

  return (
    <LoadingButton
      variant="contained"
      startIcon={<DownloadOutlined />}
      isLoading={isLoading}
      disabled={!documentUrl}
      onClick={handleClick}
    >
      Download MAA
    </LoadingButton>
  );
}
